import domus, { HgSupportedLanguage, type SupportedPlatforms } from '@smg-real-estate/domus';
import { createHead, type VueHeadClient } from '@unhead/vue/client';
import { createPinia, type Pinia } from 'pinia';
import { type App, type Component, createSSRApp } from 'vue';
import { type Router } from 'vue-router';

import { type AppI18n } from '@/i18n/setup/i18nSetup';
import createRouter from '@/router';
import { type I18n } from 'vue-i18n';

export function createVueApp(
  appComponent: Component,
  i18n: AppI18n,
  platform: SupportedPlatforms,
): {
  app: App<Element>;
  router: Router;
  pinia: Pinia;
  head: VueHeadClient;
  i18n: I18n;
} {
  const router = createRouter();
  const pinia = createPinia();
  const head = createHead();
  i18n.addRouterHook(router);

  const app = createSSRApp(appComponent);
  app.use(pinia);
  app.use(head);
  app.use(i18n.i18nInstance);
  app.use(router);
  // needs to be last as domus sets the locale when all translations are loaded
  app.use(domus, {
    theme: platform,
    i18n: { instance: i18n.i18nInstance, languages: { name: 'all', mode: 'lazy' } },
    router: { instance: router, defaultLanguage: HgSupportedLanguage.DE },
  });
  return { app, router, pinia, head, i18n: i18n.i18nInstance };
}
